import axios from "axios";
import BaseApi from "./baseApi";

export default class OrganizationApi extends BaseApi {
  getOrganizations() {
    return axios.get(this.url + "/api/organizations").then(response => {
      return response.data.result;
    });
  }

  getOrganization(businessCode) {
    return axios.get(this.url + "/api/organizations/" + businessCode).then(response => {
      return response.data.result;
    });
  }

  getMachineGroups(businessCode) {
    return axios.get(this.url + "/api/" + businessCode + "/machinegroups").then(response => {
      return response.data.result;
    });
  }

  getRoles(type) {
    return axios.get(this.url + "/api/organizations/roles/" + type).then(response => {
      return response.data.result;
    });
  }

  updateOrganization(businessCode, item) {
    return axios.patch(this.url + "/api/organizations/" + businessCode, item);
  }
}
